import axios from './axios';

/**
 * Analysis API service
 */
export const analysisApi = {
  /**
   * Get analysis for a file
   */
  getAnalysis: async (filename) => {
    const response = await axios.get(`analysis/${encodeURIComponent(filename)}/`);
    return response.data;
  },

  /**
   * Get file analysis by file ID
   */
  getFileAnalysis: async (fileId, params = {}) => {
    const response = await axios.get(`files/${fileId}/analysis/`, { params });
    return response.data;
  },

  /**
   * Get requirement detail by requirement ID
   */
  getRequirementDetail: async (requirementId) => {
    const response = await axios.get(`requirements/${requirementId}/`);
    return response.data?.data || response.data;
  },

  /**
   * Update requirement
   */
  updateRequirement: async (requirementId, data) => {
    const response = await axios.patch(
      `requirements/${requirementId}/update/`,
      data,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  },

  /**
   * Get translation progress
   */
  getTranslationProgress: async (filename) => {
    const response = await axios.get(`translation-progress/${encodeURIComponent(filename)}/`);
    return response.data;
  },

  /**
   * Get SMART analysis results
   */
  getSmartResults: async (fileId) => {
    const response = await axios.get(`files/${fileId}/smart-analysis/results/`);
    return response.data;
  },

  /**
   * Get processing queue
   */
  getProcessingQueue: async () => {
    const response = await axios.get('processing-queue/');
    return response.data;
  },

  /**
   * Cancel a queued/active processing task by type and item id
   */
  cancelProcessingTask: async (itemId, type) => {
    const response = await axios.post('processing-queue/cancel/', {
      item_id: itemId,
      type
    });
    return response.data;
  },

  resumeProcessingTask: async (itemId, type) => {
    const response = await axios.post('processing-queue/resume/', {
      item_id: itemId,
      type
    });
    return response.data;
  },

  /**
   * Clear all pending Celery tasks
   */
  clearAllCeleryTasks: async () => {
    const response = await axios.post('celery/revoke-all/');
    return response.data;
  },

  /**
   * Trigger processing
   */
  triggerProcessing: async (filename, configId) => {
    const response = await axios.post('trigger-processing/', {
      filename,
      config_id: configId
    });
    return response.data;
  },

  /**
   * Trigger SMART analysis
   */
  triggerSmartAnalysis: async (fileId, validatedOnly = false) => {
    console.log('[analysisApi.triggerSmartAnalysis] Calling endpoint:', `files/${fileId}/smart-analysis/start/`);
    console.log('[analysisApi.triggerSmartAnalysis] Request config:', {
      method: 'POST',
      url: `files/${fileId}/smart-analysis/start/`,
      headers: axios.defaults.headers.common,
      validatedOnly
    });
    
    try {
      const response = await axios.post(`files/${fileId}/smart-analysis/start/`, {
        validated_only: validatedOnly
      });
      console.log('[analysisApi.triggerSmartAnalysis] Success response:', response);
      return response.data;
    } catch (error) {
      console.error('[analysisApi.triggerSmartAnalysis] Error occurred:', error);
      console.error('[analysisApi.triggerSmartAnalysis] Error response:', error.response);
      console.error('[analysisApi.triggerSmartAnalysis] Error data:', error.response?.data);
      console.error('[analysisApi.triggerSmartAnalysis] Status code:', error.response?.status);
      throw error;
    }
  }
};

export default analysisApi;
